export const actions = {
  addNode: 'Dodaj krok',
  addStage: 'Dodaj etap',
  publish: 'Opublikuj',
  manageActionStages: 'Zarządzaj etapami',
  manageSignature: 'Zarządzaj sygnaturą',
  manageRules: 'Zarządzaj regułami',
  manageIndexes: 'Zarządzaj indeksami produktów',
  manageFlow: 'Zarządzaj szablonem konfiguracji',
  manageModels: 'Zarządzaj modelami',
  manageGroups: 'Zarządzaj grupami',
  managePackages: 'Zarządzaj pakietami',
  manageLabels: 'Zarządzaj etykietami',

  previewGroups: 'Podejrzyj grupy',
  previewPackages: 'Podejrzyj pakiety',
  previewFlow: 'Podejrzyj szablony konfiguracje',
  previewRules: 'Podejrzyj reguły',
  previewActionStages: 'Podejrzyj etapy',
  previewSignature: 'Podejrzyj sygnatury',
  previewIndexes: 'Podejrzyj indeksy produktów',
  manageControls: 'Zarządzaj kontrolkami',
  previewControls: 'Podejrzyj sterowanie',
  previewLabels: 'Podejrzyj etykiety',
} as const
